/**
 * "Internet" e "ConsoleAI" lado a lado (spec 2026-09-24-robo-painel-de-ajustes,
 * 4.5). O texto é de `conexoes.ts`; aqui só a forma: rótulo à esquerda, valor à
 * esquerda, medidas em JetBrains Mono (a `ff="monospace"` do tema).
 */
import { SimpleGrid, Stack, Text } from '@mantine/core'

import type { DuasConexoes as Conexoes, Trecho } from './conexoes'

function Valor({ trechos }: { trechos: Trecho[] }) {
  return (
    <Text size="sm">
      {trechos.map((p, i) => (p.mono
        ? <Text key={i} span size="sm" ff="monospace">{p.t}</Text>
        : <span key={i}>{p.t}</span>))}
    </Text>
  )
}

export function DuasConexoes({ conexoes }: { conexoes: Conexoes }) {
  return (
    <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="md" verticalSpacing="xs">
      <Stack gap={2} data-testid="conexao-internet">
        <Text size="sm" c="dimmed">Internet</Text>
        <Valor trechos={conexoes.internet} />
      </Stack>
      <Stack gap={2} data-testid="conexao-consoleai">
        <Text size="sm" c="dimmed">ConsoleAI</Text>
        <Valor trechos={conexoes.consoleai} />
      </Stack>
    </SimpleGrid>
  )
}
